import React from 'react';
import OptimizedImage from './OptimizedImage';

// 어종 이미지 컴포넌트
export const FishImage = ({ filename, alt, className, onError }) => (
    <OptimizedImage
        filename={filename}
        imagePath="fishes"
        alt={alt}
        className={className}
        style={{
            height: 'auto',
            objectFit: 'cover'
        }}
        placeholderStyle={{
            maxHeight: '43px'
        }}
        onError={onError}
    />
);

// 술 이미지 컴포넌트
export const DrinkImage = ({ filename, alt, className, onError }) => (
    <OptimizedImage
        filename={filename}
        imagePath="drink"
        alt={alt}
        className={className}
        style={{ 
            width: '60px', 
            height: '60px', 
            objectFit: 'contain'
        }}
        placeholderStyle={{
            width: '60px',
            height: '60px'
        }}
        onError={onError}
    />
);

// 음식 이미지 컴포넌트
export const FoodImage = ({ filename, alt, className, onError, isIngredient = false }) => (
    <OptimizedImage
        filename={filename}
        imagePath={isIngredient ? "food/ingredient" : "food"}
        alt={alt}
        className={className}
        style={{ 
            width: className === 'lure-tile-image' ? '120px' : 
                   className === 'lure-detail-image' ? '200px' : '60px', 
            height: className === 'lure-tile-image' ? '120px' : 
                    className === 'lure-detail-image' ? '200px' : '60px', 
            objectFit: 'contain'
        }}
        onError={onError}
    />
);

// 미끼/밑밥 이미지 컴포넌트
export const GroundBaitImage = ({ filename, alt, className, onError }) => (
    <OptimizedImage
        filename={filename}
        imagePath="preview"
        alt={alt}
        className={className}
        style={{ maxWidth: 80, maxHeight: 80 }}
        placeholderStyle={{
            width: '60px',
            height: '60px'
        }}
        onError={onError}
    />
);

// 바늘 이미지 컴포넌트
export const HookImage = ({ filename, alt, className, onError }) => (
    <OptimizedImage
        filename={filename}
        imagePath=""
        alt={alt}
        className={className}
        style={{ width: '60px', height: '60px', objectFit: 'contain' }}
        placeholderStyle={{
            width: '60px',
            height: '60px'
        }}
        onError={onError}
    />
);

// 루어 이미지 컴포넌트
export const LureImage = ({ filename, alt, className, onError, style }) => (
    <OptimizedImage
        filename={filename}
        imagePath="lure"
        alt={alt}
        className={className}
        style={style}
        onError={onError}
    />
);

// 릴 이미지 컴포넌트
export const ReelImage = ({ filename, alt, className, onError, style }) => (
    <OptimizedImage
        filename={filename}
        imagePath="reels"
        alt={alt}
        className={className}
        style={style}
        onError={onError}
    />
);

// 낚싯대 이미지 컴포넌트
export const RodImage = ({ filename, alt, className, onError }) => (
    <OptimizedImage
        filename={filename}
        imagePath="rods"
        alt={alt}
        className={className}
        onError={onError}
    />
);

// 오일 이미지 컴포넌트 (기존과 동일한 로직 유지)
export const OilImage = ({ filename, alt, className }) => {
    const [imageSrc, setImageSrc] = React.useState(null);
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const [imageError, setImageError] = React.useState(false);

    React.useEffect(() => {
        const loadImage = async () => {
            if (!filename) return;
            
            try {
                const imageUrl = `/data/img/${filename}`;
                const response = await fetch(imageUrl);
                
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                
                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                
                setImageSrc(blobUrl);
                setImageLoaded(true);
                
                return () => URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.warn(`Failed to load oil image ${filename}:`, error);
                setImageError(true);
            }
        };

        loadImage();
    }, [filename]);

    if (imageError) {
        return (
            <div className="image-placeholder" style={{ 
                width: '100%', 
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ddd',
                fontSize: '10px',
                borderRadius: '4px'
            }}>
                이미지 없음
            </div>
        );
    }

    if (!imageLoaded || !imageSrc) {
        return (
            <div className="image-placeholder" style={{ 
                width: '100%', 
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                borderRadius: '4px'
            }}>
                로딩중...
            </div>
        );
    }

    return (
        <img 
            src={imageSrc} 
            alt={alt} 
            className={className}
        />
    );
};
